import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Briefcase } from "lucide-react";
import { DownloadApp } from "../DownloadApp";
import { BRAND } from "../../config";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-stone-text text-white/80 mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-9 h-9 rounded-xl bg-brand flex items-center justify-center">
              <Briefcase className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading font-bold text-lg text-white">
              Restaurante<span className="text-brand">Jobs</span>
            </span>
          </div>
          <p className="text-sm max-w-sm mb-5">{t("footer.tagline")}</p>
          <p className="text-sm font-semibold text-white mb-2">{t("download.title")}</p>
          <DownloadApp variant="footer" />
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-3">{t("footer.forCandidates")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/jobs" className="hover:text-brand transition-colors">{t("nav.browse")}</Link></li>
            <li><Link to="/register" className="hover:text-brand transition-colors">{t("nav.signup")}</Link></li>
            <li><Link to="/help" className="hover:text-brand transition-colors">{t("nav.help")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-3">{t("footer.forEmployers")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-brand transition-colors">{t("nav.postJob")}</Link></li>
            <li><Link to="/help" className="hover:text-brand transition-colors">{t("nav.help")}</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-brand transition-colors">{t("nav.privacy")}</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-brand transition-colors">{t("nav.terms")}</Link></li>
            <li><Link to="/data-deletion" data-testid="footer-data-deletion" className="hover:text-brand transition-colors">{t("nav.dataDeletion")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-white/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {BRAND.name}. {t("footer.rights")}</span>
          <span>{BRAND.domain}</span>
        </div>
      </div>
    </footer>
  );
};
